module.exports = __webpack_public_path__ + "static/media/pbclsg3.6ba2f290.png";